import { render, staticRenderFns } from "./SetColorAndLogoReminder.vue?vue&type=template&id=217cb6c3&scoped=true&"
import script from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
export * from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
import style0 from "./SetColorAndLogoReminder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SetColorAndLogoReminder.vue?vue&type=style&index=1&id=217cb6c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217cb6c3",
  null
  
)

export default component.exports